/** Intersection of two sets */
export function intersection(a: Set<unknown>, b: Set<unknown>): Set<unknown> {
  return new Set([...a].filter((x) => b.has(x)));
}
